import React from "react";
import useStyles from "./style/style";
import Paper from "@material-ui/core/Paper";
import { useData } from "../../../components/firebase/DataProvider";
import Countdown from "react-countdown";
import { arrayToCurrencyString } from "../../../utils/currency";
import Typography from "@material-ui/core/Typography";

function RegisByOrder() {
  const { webstore, configuration, profil } = useData();
  const classes = useStyles();
  const daysToDelete = configuration?.auto_delete_user_register_by_order;

  function addDayToCurrentDate(days) {
    let currentDate = webstore?.created_at.toDate();
    return new Date(currentDate.setDate(currentDate.getDate() + days));
  }

  const renderer = ({ formatted }) => {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div>
          <Typography
            className={classes.timeTimer}
            variant="h4"
          >
            {formatted.days}
          </Typography>
          <Typography
            variant="caption"
            gutterBottom
            className={classes.timeTimer}
          >
            Hari
          </Typography>
        </div>
        <Typography variant="h4" className={classes.timeTimer}>
          :
        </Typography>
        <div>
          <Typography className={classes.timeTimer} variant="h4">
            {formatted.hours}
          </Typography>
          <Typography
            variant="caption"
            gutterBottom
            className={classes.timeTimer}
          >
            Jam
          </Typography>
        </div>
        <Typography variant="h4" className={classes.timeTimer}>
          :
        </Typography>

        <div>
          <Typography className={classes.timeTimer} variant="h4">
            {formatted.minutes}
          </Typography>
          <Typography
            variant="caption"
            gutterBottom
            className={classes.timeTimer}
          >
            Menit
          </Typography>
        </div>
        <Typography variant="h4" className={classes.timeTimer}>
          :
        </Typography>

        <div>
          <Typography className={classes.timeTimer} variant="h4">
            {formatted.seconds}
          </Typography>
          <Typography
            variant="caption"
            gutterBottom
            className={classes.timeTimer}
          >
            Detik
          </Typography>
        </div>
      </div>
    );
  };
  return (
    <Paper elevation={0} className={classes.containerRegisByOder}>
      <div style={{ textAlign: "center", paddingTop: 10, paddingBottom: 10 }}>
        <div>
          <Typography variant="caption" className={classes.keterTime}>Register By Order</Typography>
        </div>
        <div>
          <Countdown
            date={addDayToCurrentDate(daysToDelete)}
            zeroPadTime={2}
            renderer={renderer}
          />
        </div>
        <div>
          <Typography variant="caption" className={classes.keterTime}>
            Segera lakukan pembelian sebesar{" "}
            {arrayToCurrencyString(
              configuration?.registration_fee?.[profil?.tipe_akun]
            )}{" "}
            agar akun anda aktif dan dapat menikmati semua fitur Tokorame
          </Typography>
        </div>
      </div>
    </Paper>
  );
}

export default RegisByOrder;
